/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

/**
 * Zod, without `new Function` (CMP-28).
 *
 * By default Zod compiles a fast parser for every object schema, and first
 * probes whether it may by calling `new Function('')`. The
 * Content-Security-Policy allows no eval, so the probe is refused: Zod catches
 * that and falls back, but the browser still reports a violation on every page
 * load. `jitless` skips the probe and the compiled parser alike.
 *
 * The probe runs when a schema is *built*, and schemas are built as their
 * modules load, so the setting has to be in place before any of them. Setting
 * it from `main.tsx` is too late: the bundler evaluates the entry's imports, and
 * every schema in them, before the entry's own code. So `vite.config.ts`
 * resolves `import { z } from 'zod'` to this module, which sets it as Zod
 * loads, before anything that imports Zod can build a schema. Code imports
 * from `'zod'` as usual; only this file names `'zod/v4'`, which is the same
 * package, so there is one Zod and one configuration.
 */

import { z } from 'zod/v4';

z.config({ jitless: true });

export * from 'zod/v4';
export { z };
